import type { AvailableSeason } from '@/pages/SeasonSelectionPage/SeasonCard'
import { useQuery } from '@tanstack/react-query'
import { getSeasons } from '@/api'
import { queryKeys } from '@/query/queryKeys'

export interface SeasonsFromStatus {
  archived: string[]
  current_season: string
  in_progress: string[]
}

export function useSeasons() {
  return useQuery({
    queryKey: queryKeys.seasons(),
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = getSeasons<SeasonsFromStatus>()
        return response.then((seasons) => {
          const formattedSeasons: AvailableSeason[] = []
          seasons.archived.forEach((season) => {
            formattedSeasons.push({ season, status: 'archived' })
          })
          formattedSeasons.push({ season: seasons.current_season, status: 'active' })
          seasons.in_progress.forEach((season) => {
            formattedSeasons.push({ season, status: 'in-progress' })
          })
          return formattedSeasons
        })
      }
    },
  })
}
